import { useSelector } from 'react-redux';
import { getUser } from '../../modules/selectors';
import { getPaymentInfo } from '../../modules/selectors/paymentInfo';
import { isBillingAddressFilled } from '../../common/is-billing-address-filled';
import { isTaxConfirmed } from '../../common/is-tax-confirmed';

export interface PaymentPrerequisite {
  id: string;
  isMet: boolean;
  tooltipKey: string;
}

export function usePaymentPrerequisites(): PaymentPrerequisite[] {
  const { address: billingAddress } = useSelector(getPaymentInfo);
  const { taxSettings } = useSelector(getUser);

  return [
    {
      id: 'billing-address',
      isMet: isBillingAddressFilled(billingAddress),
      tooltipKey: 'shop.paymentSettings.billingAddressIsRequired'
    },
    {
      id: 'tax-details',
      isMet: isTaxConfirmed(taxSettings),
      tooltipKey: 'shop.paymentSettings.taxDetailsIsRequired'
    }
  ];
}
